import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api`;

/**
 * Custom hook to track page views
 * Automatically sends page view data to the analytics backend
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    const trackPageView = async () => {
      try {
        const pagePath = location.pathname + location.search;
        const referrer = document.referrer || '';

        await fetch(`${API_BASE_URL}/analytics/track`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            pagePath,
            referrer,
          }),
        });

        // Silent tracking - no error handling needed for analytics
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackPageView();
  }, [location.pathname, location.search]);
};
